/* eslint-disable */
import {
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  Heading,
  Text,
  useToast,
  useColorModeValue,
  Icon
} from "@chakra-ui/react";
import { Link, useNavigate } from "react-router-dom";
import { RxCross2 } from "react-icons/rx";
import { useDispatch, useSelector, useStore } from "react-redux";
import { BiUserCircle } from "react-icons/bi";
import { capitalizeFirstLetter } from "../Redux/UserReducer/action";
import { 
  FaUserShield, FaHome, FaChartLine, FaChalkboardTeacher, 
  FaBookOpen, FaUsers, FaUserFriends, FaTags, FaVideo, FaCog, FaBrain 
} from "react-icons/fa";
import { IoIosArrowForward } from "react-icons/io";
import axios from "axios";
import { actionUserLogout } from "../Redux/UserReducer/actionType";
import { showToast } from "./SignUp";
import { useModalToast } from "../context/GlobalModalToast";

export function NavBarDrawer({ isOpen, onClose }) {
  const userStore = useSelector((store) => store.UserReducer);
  const drawerItems = {
    "": [
      "For Businesses",
      "For Universities",
      "For Governments",
      "Online Degrees",
      "Find your new career",
    ],
    Goals: ["Take a free course", "Earn a Degree", "Earn a Certificate"],
    Subjects: [
      "Date Science",
      "React",
      "Computer Science",
      "Information Technology",
      "Language Learning",
      "Health",
      "Math and Logic",
      "Arts and Humanites",
    ]};
  const navigate = useNavigate();
  const { toast } = useModalToast();

  const dispatch = useDispatch();

  const handleLogoutClick = () => {
    const token = userStore?.token;
    const headers = {
      Authorization: `Bearer ${token}`};
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/api/auth/logout`,
        {},
        { headers }
      )
      .then((res) => {
        localStorage.removeItem("user");
        sessionStorage.clear();
        dispatch(actionUserLogout());
        showToast({
          toast,
          message: "You have Logout Successfully",
          color: "green"});
        navigate("/");
      })
      .catch((err) => console.log(err));
  };

  const drawerBg = useColorModeValue("white", "gray.900");
  const headerBg = useColorModeValue("#f5f5f5", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.700");
  const textColor = useColorModeValue("gray.800", "gray.100");
  const hoverBg = useColorModeValue("purple.50", "whiteAlpha.200");
  const iconColor = useColorModeValue("purple.500", "purple.300");

  const NavItem = ({ to, icon, label, color }) => (
    <Link to={to}>
      <Flex 
        align="center" 
        p="0.8rem 1rem" 
        borderRadius="md" 
        _hover={{ bg: hoverBg, transform: 'translateX(4px)' }} 
        transition="all 0.2s"
        gap={3}
      >
        {icon && <Icon as={icon} color={color || iconColor} boxSize="1.1rem" />}
        <Text fontSize="0.9rem" fontWeight="600" color={color || "inherit"}>
          {label}
        </Text>
        <Box flex={1} />
        <Icon as={IoIosArrowForward} color="gray.400" boxSize="0.9rem" />
      </Flex>
    </Link>
  );

  return (
    <Box>
      <Drawer placement={"top"} onClose={onClose} isOpen={isOpen}>
        <DrawerOverlay />
        <DrawerContent bg={drawerBg} color={textColor}>
          <DrawerHeader
            borderBottomWidth="1px"
            borderColor={borderColor}
            bg={headerBg}
            boxShadow="0 4px 6px rgba(0, 0, 0, 0.1)"
            display="flex"
            justifyContent="space-between"
          >
            <Link to="/">
              <Flex align="center">
                <svg width="28" height="28" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '8px' }}>
                  <circle cx="50" cy="50" r="45" stroke="url(#eramGradDrawer)" strokeWidth="8" fill="none" />
                  <path d="M25 50C25 35 37.5 22.5 52.5 22.5C67.5 22.5 75 35 75 50C75 65 62.5 77.5 47.5 77.5C32.5 77.5 25 65 25 50Z" fill="url(#eramGradDrawer)" opacity="0.8" />
                  <path d="M35 50C35 42 41 36 48.5 36C56 36 65 42 65 50C65 58 59 64 51.5 64C44 64 35 58 35 50Z" fill="#ffffff" />
                  <defs>
                    <linearGradient id="eramGradDrawer" x1="0" y1="0" x2="100" y2="100" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#1e3a8a" />
                      <stop offset="0.5" stopColor="#2563eb" />
                      <stop offset="1" stopColor="#0ea5e9" />
                    </linearGradient>
                  </defs>
                </svg>
                <Text
                  fontSize="2xl"
                  fontWeight="850"
                  letterSpacing="-1px"
                  display="flex"
                  alignItems="center"
                >
                  <span style={{ color: "#1e3a8a", marginRight: "4px" }}>ERAM</span>
                  <span className="text-gradient">SkillUp</span>
                </Text>
              </Flex>
            </Link>
            <Box>
              <RxCross2 size="1.5rem" onClick={onClose} />
            </Box>
          </DrawerHeader>
          <DrawerBody >
            {userStore?.isAuth ? (
              <Flex justify="space-between" alignItems="center">
                <Box p="1.5rem 0">
                  {userStore?.role === "admin" || userStore?.role === "super_admin" || userStore?.role==='instructor' ? (
                    <Flex alignItems={"center"}>
                      <Box>
                        <FaUserShield size="2rem" color="#0056d2" />
                        <Text fontSize="0.6rem" fontWeight="bold">
                          {capitalizeFirstLetter(userStore?.role)}
                        </Text>
                      </Box>
                      <Heading size="sm" ml="1rem">
                        {capitalizeFirstLetter(userStore?.name)}
                      </Heading>
                    </Flex>
                  ) : (userStore?.role === "user" || userStore?.role === "employee") ? (
                    <Flex alignItems={"center"}>
                      <BiUserCircle size="2rem" color="#0056d2" />
                      <Heading size="sm" ml="1rem">
                        {capitalizeFirstLetter(userStore?.name)}
                      </Heading>
                    </Flex>
                  ) : null}
                </Box>
                <Button
                  fontSize="0.8rem"
                  p="1rem"
                  colorScheme="blue"
                  fontWeight={"bold"}
                  onClick={handleLogoutClick}
                >
                  Logout
                </Button>
              </Flex>
            ) : null}
            <Box py={2}>
              {(userStore?.role === "admin" || userStore?.role === "super_admin") && (
                <>
                  <NavItem to="/profile" icon={BiUserCircle} label="Your Account" />
                  <NavItem to="/home" icon={FaHome} label="Employee Dashboard" />
                  <NavItem to="/admin/dashboard" icon={FaChartLine} label="Admin Dashboard" />
                  <NavItem to="/admin/teacher-insights" icon={FaChalkboardTeacher} label="Instructor Insights" />
                  <NavItem to="/admin/courses" icon={FaBookOpen} label="Courses" />
                  <NavItem to="/admin/users" icon={FaUsers} label="Users" />
                  <NavItem to="/admin/groups" icon={FaUserFriends} label="Project Groups" color="purple.500" />
                  <NavItem to="/admin/categories" icon={FaTags} label="Categories" color="purple.500" />
                  <NavItem to="/admin/upload-lna-quiz" icon={FaBrain} label="LNA Quiz Admin" color="purple.500" />
                  <NavItem to="/admin/videos" icon={FaVideo} label="All Videos" />
                  <NavItem to="/teacher-dashboard" icon={FaVideo} label="Live Sessions" color="blue.500" />
                  <NavItem to="/admin/setting" icon={FaCog} label="Settings" />
                </>
              )}

              {userStore?.role === 'instructor' && (
                <>
                  <NavItem to="/profile" icon={BiUserCircle} label="Your Account" />
                  <NavItem to="/home" icon={FaHome} label="Employee Dashboard" />
                  <NavItem to="/teacher-dashboard" icon={FaChalkboardTeacher} label="Instructor Dashboard" />
                  <NavItem to="/manager/dashboard" icon={FaChartLine} label="Team Progress (Manager)" color="blue.500" />
                  <NavItem to="/Teacher/courses" icon={FaBookOpen} label="Courses" />
                  <NavItem to="/Teacher/setting" icon={FaCog} label="Settings" />
                </>
              )}

              {(userStore?.role === "user" || userStore?.role === "employee") && (
                <>
                  <NavItem to="/profile" icon={BiUserCircle} label="Your Account" />
                  <NavItem to="/home" icon={FaHome} label="Dashboard" />
                  <NavItem to="/lna-quizzes" icon={FaBrain} label="LNA Quizzes" color="purple.500" />
                </>
              )}
            </Box>

              <Box borderTop="1px solid" borderColor={borderColor} pt={2} mt={2}>
                {Object.entries(drawerItems).map(([category, items]) => (
                  <Box key={category} mb={4}>
                    {category && (
                      <Heading m="10px 0 10px 15px" size="xs" color="gray.500" textTransform="uppercase" letterSpacing="1px">
                        {category}
                      </Heading>
                    )}
                    <Box>
                      {items.map((item) => (
                        <Flex
                          key={item}
                          align="center"
                          p="0.6rem 1.5rem"
                          borderRadius="md"
                          _hover={{ bg: hoverBg, color: iconColor }}
                          cursor="pointer"
                          transition="all 0.2s"
                        >
                          <Text fontSize="0.85rem" fontWeight="500">
                            {item}
                          </Text>
                        </Flex>
                      ))}
                    </Box>
                  </Box>
                ))}
              </Box>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Box>
  );
}
